import i18n from '@/plugins/i18n'
import Vue from 'vue'
export default function useLanguageTree () {
  const root = 'en-US'
  let supportedLanguages = new Map()
  supportedLanguages.set('en-US', root)
  supportedLanguages.set('es-ES', 'en-US')
  supportedLanguages.set('it-IT', 'en-US')
  supportedLanguages.set('fr-FR', 'en-US')
  supportedLanguages.set('ca-ES', 'es-ES')
  supportedLanguages.set('ca-AD', 'ca-ES')
  supportedLanguages.set('es-MX', 'es-ES')
  supportedLanguages.set('es-CO', 'es-ES')
  supportedLanguages.set('es-CL', 'es-ES')
  supportedLanguages.set('es-AR', 'es-ES')
  supportedLanguages.set('eu-ES', 'es-ES')

  function getAvailableLang (locale, targetObject, transformFunction) {
    if (!targetObject) {
      return root
    }
    let current = supportedLanguages.get(locale) ? locale : root
    let needTransformation = transformFunction && typeof transformFunction === 'function'

    while (current !== root && !!current) {
      if (targetObject[needTransformation ? transformFunction(current) : current]) {
        return current
      }
      let parent = supportedLanguages.get(current)
      if (targetObject[needTransformation ? transformFunction(parent) : parent]) {
        return parent
      }
      current = parent
    }
    return root
  }
  function getAvailableLangByCondition (locale, conditionFunction) {
    let current = supportedLanguages.get(locale) ? locale : root
    let conditionResult = conditionFunction('')
    let isPromise = conditionResult && typeof conditionResult.then === 'function'
    let promises = []
    while (current !== root && !!current) {
      if (isPromise) {
        promises.push(conditionFunction(current))
      } else if (conditionFunction(current) === true) {
        return current
      }
      current = supportedLanguages.get(current)
    }
    if (isPromise) {
      return Promise.allSettled(promises)
        .then((results) => {
          let f = results.find(result => result.status === 'fulfilled' && result.value !== false)
          return f ? f.value : root
        }).catch(e => {
          Vue.$log.error(e)
        })
    }
    return root
  }

  function getObjectWithLangFallback (locale, targetObject, transformFunction) {
    let current = supportedLanguages.get(locale) ? locale : root
    let needTransformation = transformFunction && typeof transformFunction === 'function'

    while (current !== root && !!current) {
      if (targetObject[needTransformation ? transformFunction(current) : current]) {
        return targetObject[needTransformation ? transformFunction(current) : current]
      }
      let parent = supportedLanguages.get(current)
      if (targetObject[needTransformation ? transformFunction(parent) : parent]) {
        return targetObject[needTransformation ? transformFunction(parent) : parent]
      }
      current = parent
    }
    return targetObject[needTransformation ? transformFunction(root) : root] || null
  }

  function t (key, ...values) {
    let currentLocale = i18n.locale
    let currentTranslation = i18n._t(key, i18n.locale, i18n._getMessages(), null, ...values)
    if (!i18n.te(key, currentLocale) &&
      (i18n.messages[currentLocale] && typeof i18n.messages[currentLocale][key] === 'undefined')) {
      while (currentLocale !== i18n.fallbackLocale && currentLocale !== root && !!currentLocale) {
        currentLocale = supportedLanguages.get(currentLocale)
        if (i18n.te(key, currentLocale) || typeof i18n.messages[currentLocale][key] !== 'undefined') {
          return i18n._t(key, currentLocale, i18n._getMessages(), null, ...values)
        }
      }
    }
    return currentTranslation
  }
  return {
    t,
    supportedLanguages,
    getAvailableLangByCondition,
    getAvailableLang,
    getObjectWithLangFallback
  }
}
